export default __webpack_public_path__ + "static/media/sipperbottle.e3504b7a.jpg";